// extracted by mini-css-extract-plugin
export default {"mainContent":"mainContent__oST0l","contentWrap":"contentWrap__TrxA5","grid":"grid__tH9HB","pageOpac":"pageOpac__HeUq5"};